import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const NavView = errorBoundary(
    class extends React.PureComponent {
        static propTypes = {
            content: PropTypes.array,
        };

        render() {
            const list = Array.isArray(this.props.content) ? this.props.content : [];

            if (!list.length) return null;

            return (
                <nav className={styles.col_box} aria-label="频道导航">
                    <div className={styles.col_navlist}>
                        <ul className="clearfix">
                            {list.map((item, index) => (
                                <li key={item.url || index} className={index === 0 ? styles.pa : ''}>
                                    <a target="_blank" title={item.title} href={item.url} rel="noopener noreferrer">
                                        {item.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </nav>
            );
        }
    },
);

class Navigation extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <Chip id="261189" type="struct" title="原创导航" groupName="导航栏" content={content}>
                <NavView />
            </Chip>
        );
    }
}

export default errorBoundary(Navigation);
